import { http } from '@/store/api/http-common';

const exportDashboardReport = async (params) => {
	try {
		const response = await http.get('reporte-dashboard', {
			params,
			responseType: 'blob',
		});

		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;

		const timestamp = new Date().toISOString().slice(0, 16).replace('T', '_').replace(':', '-');
		link.setAttribute('download', `ReporteDashboard_${timestamp}.xlsx`);
		document.body.appendChild(link);
		link.click();
		link.remove();

		return true;
	} catch (error) {
		return Promise.reject(error);
	}
};

export { exportDashboardReport };
